import url from 'url';

export default () => url.parse(window.location.href, true).query;
